export default {
  buttons: {
    back: 'Zurück',
  },
};
